var React = require('react');
var cx = require('classnames');

import { connect } from 'react-redux';
import InnerCalendar from './InnerCalendar.jsx';
import Legend from './Legend.jsx';
import PeriodComparator from './PeriodComparator.jsx';
import DateHolder from './DateHolder';
import Translator from "bazinga-translator";
import { calculatePrices } from './actions';

class Calendar extends React.Component {
    constructor(props, context) {
        super(props, context);
        var route = ["show_accommodation", "show_accommodation_with_dates"];
        var popupcalendar = cvtemplating.calendar_in_sidebar && (route.indexOf(cvtemplating.route) > -1) ? true : false;

        if(props.static) popupcalendar = false;

        this.state = { 
            hideCalendar: popupcalendar ? true : !props.visible,
            popUpClass: popupcalendar ? 'popupcalendar' : '',
            popupcalendar: popupcalendar,
            calendarLabel: props.visible ? Translator.trans('calendar.close', {}, 'messages') : Translator.trans('calendar.show', {}, 'messages'),
            refresh: {
                start:null,
                end: null
            }
        };
    }
    
    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        
        const $parent = this;
        
        document.addEventListener("Calendar_RANGES_CHANGED", function(e){
            $parent.setState( () => ({
                refresh: e.detail.dates
            }));
        });

        this.props.dispatch(calculatePrices());
    }
    
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }
    
    setWrapperRef = node => {
        this.wrapperRef = node;
    };

    handleClickOutside = event => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.popupcalendar) {
            this.setState({ hideCalendar: true });
            
            let calendarBookingStatic = document.getElementById('calendar-booking-static');
            if(calendarBookingStatic) {
                calendarBookingStatic.style.opacity = '1';
                calendarBookingStatic.style.pointerEvents = 'auto';
            }
        }
    };
    
    getErrorMessage() {
        if (this.props.errorMessage) {
            return (<div className="error-message">{this.props.errorMessage}</div>);
        }
    }

    toggleCalendar () {
        const hideCalendar = !this.state.hideCalendar;
        
        this.setState({ 
            hideCalendar: hideCalendar
        });

        let calendarBookingStatic = document.getElementById('calendar-booking-static');
        if(calendarBookingStatic){
            calendarBookingStatic.style.opacity = hideCalendar ? '1' : '0.3';
            calendarBookingStatic.style.pointerEvents = hideCalendar ? 'auto' : 'none';
        }

        this.setState({ 
            calendarLabel: hideCalendar ? Translator.trans('calendar.close', {}, 'messages') : Translator.trans('calendar.show', {}, 'messages'),
        });
    }

    renderHideCalendar () {
        if(this.props.static) return (null);
        
        return (<div className="text-right mb-3" key="calendarToggleContainer"><button type="button" className="btn btn-tertiary btn-xs ucfirst"  onClick={this.toggleCalendar.bind(this)} key="calendarToggleButton">{this.state.calendarLabel}</button></div>);
    }
    
    visibilitySwitch(value){
        this.setState({ hideCalendar: value });
    }
    
    render() { 
        let t = Translator;
        var classCalendar =  cx('calendar', 'text-blue1', 'mx-1', 'mt-3') + ' ' + this.state.popUpClass + ' ' + ( this.state.popupcalendar ? cx('flex flex-column items-center') : ''),
            DateHolderLabels = {
                arrival: t.trans('arrival', {}, 'messages'),
                departure: t.trans('departure', {}, 'messages'),
                select: t.trans('select', {}, 'messages')
            };
        
        if ( !this.state.hideCalendar ) {
            return (
                <div>
                    {this.state.popupcalendar ? <DateHolder hideCalendar={this.state.hideCalendar} onChange={value => this.visibilitySwitch(value)} labels={DateHolderLabels} key="DateHolder" /> : ''}
                    {this.state.popupcalendar ? '' : this.renderHideCalendar()}
                    <div id="calendar-container" key="calendarContainer" ref={this.setWrapperRef} className={ classCalendar } data-toggle-target="calendar-container" popupcalendar={this.state.popupcalendar ? 1 : null}>
                        {this.state.popupcalendar ? <span className="calendarOutboundArrow" key="calendarOutboundArrow"></span> : ''}
                        {this.state.popupcalendar ? <div className="text-right" key="toggleButtonContainer"><button type="button" className="btn-no bor-no pad-no font-120 bg-no" onClick={this.toggleCalendar.bind(this)} key="toggleButton"><strong key="toggleButtonStrong">&times;</strong></button></div> : ''}
                        <InnerCalendar 
                        popupcalendar={this.state.popupcalendar ? 1 : null} 
                        key="InnerCalendar" t={t}
                        interactive={this.props.interactive}
                        refresh={this.state.refresh}
                        selector={this.props.selector}
                        static={this.props.static}
                        />
                        <Legend 
                        key="calendarLegend" 
                        t={t}
                        interactive={this.props.interactive}
                        static={this.props.static} 
                        />
                    </div>
                    {this.getErrorMessage()}
                    <PeriodComparator 
                    popupcalendar={this.state.popupcalendar ? 1 : null} 
                    key="PeriodComparator" t={t}
                    interactive={this.props.interactive}
                    static={this.props.static}
                    />
                </div>
            );
         } else  {
            return (
                <div>
                    {this.state.popupcalendar ? <DateHolder hideCalendar={this.state.hideCalendar} onChange={value => this.visibilitySwitch(value)} labels={DateHolderLabels} key="DateHolder" /> : ''}
                    {this.state.popupcalendar ? '' : this.renderHideCalendar()}
                    <PeriodComparator popupcalendar={this.state.popupcalendar ? 1 : null} key="PeriodComparator" t={t}/>
                </div>

            );
        }
    }
}

const mapStateToProps = (state) => ({
    errorMessage: state.calendarStore.errorMessage,
    visible: state.calendarStore.visible
});

export default connect(mapStateToProps)(Calendar);
